import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudSimpleUpload: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudSimpleUpload"><Path d="M17.5 19.494C20.2834 19.3609 22.5 17.016 22.5 14.1429C22.5 11.1842 20.1495 8.78571 17.25 8.78571C16.6775 8.78571 16.1263 8.87923 15.6105 9.05211C14.4881 6.37545 11.8837 4.5 8.85 4.5C4.79071 4.5 1.5 7.85786 1.5 12C1.5 15.3036 3.59316 18.1082 6.5 19.1085M9.5 16L12 13.5L14.5 16M12 20.25V14.256" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudSimpleUpload;
